<template>

    <FloatingPanel>

        <div class="canvas-blocks-sky-headerAlfa-BlockPanel">

            <Tabs :tabs="[
                'Algemeen',
                'Design',
            ]">

                <div slot="Algemeen">

                    <SwitchInput label="Fade/Vervagen animatie"
                        instruction="Wil je dat het overloopt of dat het een 'veeg animatie' heeft als het naar de volgende slide gaat."
                        :items="[
                            { value: '1', label: 'Ja'},
                            { value: '0', label: 'Nee'},
                        ]"
                        :options="options"
                        options-property="sliderAnimation"
                        defaultValue="0"
                        :open="true"
                    />

                    <SwitchInput label="Header vastzettten"
                        instruction="Zet de header vast aan de bovenkant van de pagina."
                        :items="[
                            { value: '1', label: 'Ja'},
                            { value: '0', label: 'Nee'},
                        ]"
                        :options="options"
                        options-property="header_fixed" 
                        defaultValue="0"
                        :open="true"
                    />

<!--            <SwitchInput label="Uitlijning slider tekst"-->
<!--                         instruction="Kies waar de slider teksten worden uitgelijnd"-->
<!--                         :items="[-->
<!--                             { value: 'left', label: 'Links'},-->
<!--                             { value: 'center', label: 'Midden'},-->
<!--                             { value: 'right', label: 'Rechts'},-->
<!--                         ]"-->
<!--                         :options="options"-->
<!--                         options-property="slider-text-alignment"/>-->

                </div>

                <div slot="Design">
                    <CommonInputs :options="options" :open="false" />
                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";

export default {

    extends: AbstractPanel,

    components: {
        SwitchInput,
        FloatingPanel,
        CommonInputs,
        Tabs,
    },
}

</script>

<style lang="scss" scoped>

.canvas-blocks-sky-headerAlfa-BlockPanel {

}

</style>
